import { normalizeFocus } from '@/lib/imageFocus'

// These are the canonical, member-bookable sport keys seeded by memberFacilities.
// Facility enablement, ordering, names and media remain owned by that resource.
const PLAY_SPORTS = Object.freeze({
  golf: { slug: 'golf', supportingLine: 'Play a round' },
  tennis: { slug: 'tennis', supportingLine: 'Take to the court' },
  squash: { slug: 'squash', supportingLine: 'Take to the court' },
  pickleball: { slug: 'pickleball', supportingLine: 'Take to the court' },
  padel: { slug: 'padel', supportingLine: 'Take to the court' },
})

export function resolveSafeFacilityImage(value) {
  if (typeof value !== 'string') return null
  const image = value.trim()
  return /^(https:\/\/|data:image\/|blob:)/i.test(image) ? image : null
}

export function resolveLetsPlaySports(facilities) {
  if (!Array.isArray(facilities)) return []
  return facilities.flatMap((facility) => {
    const key = String(facility?.facility_key || facility?.facilityKey || '').toLowerCase()
    const definition = PLAY_SPORTS[key]
    if (!definition || facility?.is_enabled === false) return []
    return [{
      id: String(facility.id || key),
      key,
      slug: definition.slug,
      title: facility.display_name || facility.displayName || key,
      ...(facility.display_name_key ? {titleKey:facility.display_name_key} : {}),
      supportingLine: definition.supportingLine,
      imageUrl: resolveSafeFacilityImage(facility.image_url || facility.imageUrl),
      imageFocus: {
        x: normalizeFocus(facility.image_focus_x ?? facility.imageFocusX),
        y: normalizeFocus(facility.image_focus_y ?? facility.imageFocusY),
      },
    }]
  })
}

export function resolveEligibleLetsPlaySport(sports, slug) {
  if (!slug || !Array.isArray(sports)) return null
  return sports.find((sport) => sport.slug === slug) || null
}
